import { z } from 'zod';
// CourseManifest declares which components a course uses.
// Unlisted components are not enabled. Engine reads manifest, looks up
// componentRegistry, instantiates only the listed ones.
//
// A component entry is either a bare id ("dashboard") or an object with config.
// The config shape is component-specific and enforced by that component's mount().
export const ComponentManifestEntrySchema = z.union([
    z.string(),
    z.object({
        id: z.string().min(1),
        config: z.unknown().optional(),
    }),
]);
export const CourseManifestSchema = z.object({
    /** Stable course id; matches `courses/<id>/` in v1, matches DB row id in v2. */
    id: z.string().regex(/^[a-z][a-z0-9_-]*$/, 'course id must be slug'),
    /** Display title in sidebar header. */
    title: z.string().min(1),
    /** Optional sub-line under title. */
    subtitle: z.string().optional(),
    /** ISO datetime of the exam (or null if no specific date). */
    examDate: z.string().datetime().nullable().optional(),
    /** Storage key for localStorage-backed v1 isolation. v2 uses DB user_id; this field is v1-only. */
    storageKey: z.string().optional(),
    /** Components this course enables. Order = sidebar nav order. */
    components: z.array(ComponentManifestEntrySchema).min(1),
    /** Per-course label override for "case" vs "topic". */
    caseLabel: z.enum(['Case', 'Topic']).default('Case'),
    /** Forward-compatible bag for course-level config (mockMCQCount, examDuration, etc.). */
    meta: z.record(z.unknown()).optional(),
});
//# sourceMappingURL=course-manifest.js.map